import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Editor from "../../utils/common/Editor";
import { Avatar, Divider, Typography } from "@mui/material";

const EmailGenerateItems = ({
  content,
  handleInsertReply,
  index,
  totalGeneratedItems,
  messageId,
}: any) => {
  const handleOnChange = (value: any) => {};

  return (
    <Box
      sx={{
        border: "1px solid rgba(60, 64, 67, 0.2)",
        borderRadius: "8px",
        padding: "5px",
        background: "#fff",
        marginBottom: "10px",
      }}
    >
      <Box mb="9px">
        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "5px 0px 5px 9px",
            fontSize: "12px",
            opacity: "0.8",
            color: "#092146",
          }}
          className="aiReccomIndexTypo"
        >
          #{totalGeneratedItems - index}
          {/* <Avatar className="aiReccomIndex">
            {totalGeneratedItems - index}{" "}
          </Avatar> */}
        </Typography>
        <Divider />
        <Editor
          readOnly
          editorData={content}
          updateData={handleOnChange}
          hideToolbar
          className="aigenerate"
        />
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        sx={{ margin: "10px", background: "#fff" }}
      >
        <Box>
          <Button
            variant="contained"
            sx={{
              borderRadius: "8px",
              boxShadow: "none",
            }}
            onClick={() => handleInsertReply(content, messageId)}
          >
            INSERT
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default EmailGenerateItems;
